/**
 * Hook for managing supplier draft state
 */
import { ENTITY_TYPES } from "@/shared/contexts/DraftContext/DraftContext";
import { createEntityDraftHook } from "@/shared/hooks/drafts";
import type { SupplierFormData } from "../schemas/supplier.schema";

export const useSupplierDraft = createEntityDraftHook<SupplierFormData>(
  ENTITY_TYPES.SUPPLIER,
  "useSupplierDraft",
);
